<section class="sorteo-egresados-anahuac so3">
    <div class="container">
        <div class="row">

            <div class="col-lg-7 my-auto text-center d-lg-block d-none">
                <img src="/assets/images/sorteo2026/oportuno/women.png" class="img-fluid"
                    alt="Ganadores Sorteo Anáhuac Magno">
            </div>

            <div class="col-lg-5 my-auto text-center">
                <h1>
                    1° SORTEO
                    <span class="paragraph d-block w-100  mx-auto">OPORTUNO</span>
                </h1>

            </div>



        </div>
    </div>
</section>


<section class="stc-winners-opt so2">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 style="background-color:#662380 !important; padding: 15px;">
                  LISTA DE PARTICIPANTES 
                    <span class="d-block">
                      1° SORTEO OPORTUNO 2026
                    </span>
                </h2>
            </div>


            <div class="col-md-12">
                <div class="text-center" style="overflow-x: auto;">
                    <label for="search" class="mt-5"
                        style="text-align: left !important; width: 100%; font-weight: 600; font-size: 18px;">Buscar:</label>
                    <input id="search" type="text" class="form-control mb-3" placeholder="Ingresa nombre o folio"
                        [(ngModel)]="searchText" (input)="filterData()" />

                    <table class="table table-striped table-hover mt-3">
                        <thead>
                            <tr class="cols">
                                <th scope="col" style="width: 30%;"><span>FOLIO</span></th>
                                <th scope="col" style="width: 70%;"><span>NOMBRE</span></th>
                            </tr>
                        </thead>
                        <tbody class="text-center">
                            <tr
                                *ngFor="let participante of filteredData | paginate: { itemsPerPage: 50, currentPage: p }">
                                <td class="text-center align-middle" style="width: 30%;">
                                    <strong>{{ participante.folio }}</strong>
                                </td>

                                <td class="text-center align-middle text-uppercase" style="width: 70%;">
                                    {{ participante.nombre }}
                                </td>
                            </tr>

                            <tr *ngIf="filteredData.length === 0">
                                <td colspan="2" class="text-center text-muted py-4 align-middle">
                                    No se encontraron datos.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <pagination-controls (pageChange)="p = $event" previousLabel="Anterior"
                        nextLabel="Siguiente"></pagination-controls>
                </div>
            </div>


            <!-- Repite lo mismo para las otras dos tablas -->



            <div class="col-12 mt-5 pt-0 footer-egr">
                <p>
                    <strong>
                        SORTEO ANÁHUAC MAGNO
                    </strong>
                </p>

                 <p>
                    <strong>
                        PRIMER SORTEO OPORTUNO 
                    </strong>
                </p>

                <p>
                    <strong>ENTREGA DE PREMIOS:</strong>
                </p>



                <p>
                  <strong class="font-bold">Los premios mayores a 1,500 (UMA) $175,965.00 (Ciento setenta y cinco mil novecientos sesenta y cinco pesos 00/100 m.n.)</strong> se solicitará la presencia de un inspector de la DGJS para la entrega de estos, conforme al siguiente calendario de fechas: 05 de junio de 2026 a las 12:00 horas, entrega del Premio 1 de comprador, del Primer Sorteo Acumulado Especial de Compradores y Colaboradores Oportunos del SORTEO ANAHUAC MAGNO. En las instalaciones de la Universidad Anáhuac México Campus Norte con domicilio en Av. Universidad Anáhuac no. 46 Huixquilucan, Estado de México. C.P. 52786. 
                </p>


                <p>
                    Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses), Constancia de situación fiscal (mes en curso) y CURP; el nombre completo escrito en el boleto debe corresponder exactamente con el del talón o con el registro en la APP del Sorteo Anáhuac y su identificación oficial. 
                </p>

                <p>
                    En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800. 
                </p>

                <p>
                    Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para recibirlos diríjase a: <a href="http://www.sorteoanahuac.mx" target="_blank" style="color: #ff5900;">www.sorteoanahuac.mx</a>, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 2137. 
                </p>
               

                <p>
                    <strong>
                       PERMISO SEGOB: 20260061PS09 
                    </strong>
                </p>
            </div>


        </div>
    </div>
</section>